export default __webpack_public_path__ + "static/media/Hooch_Booch_Can_Animation.002199ba.gif";